import { Link } from 'react-router-dom';
import styled from 'styled-components';
import theme from '@styles/theme';

import { RegularFont } from '@components/styled/StyledComponents';

export const LoginForm = styled.form`
    margin: 150px auto;
    width: 343px;
`;
export const Wrapper = styled.div<{ $margin?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : '150px auto')};
    width: 343px;
`;
export const Title = styled.h2`
    ${theme.typography.mediumTitle}
    margin-bottom: 20px;
    font-family: PretendardMedium, sans-serif;
    text-align: center;
`;
export const SubTitle = styled.div`
    ${theme.typography.bodyMobile}
    margin-bottom: 40px;
    color: ${theme.colors.grayIconColor};
    text-align: center;
`;
export const LinkButton = styled(Link)`
    ${theme.typography.bodyMobile}
    position: relative;
    text-align: right;
    color: ${theme.colors.grayIconColor};
    &:last-of-type {
        padding-left: 17px;
        &::before {
            content: '';
            position: absolute;
            top: 4px;
            left: 0;
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: ${theme.colors.grayIconColor};
            margin: 0 8px;
        }
    }
`;
export const JoinButton = styled.button<{ $fontColor?: string }>`
    line-height: 1;
    margin-left: 8px;
    font-size: 14px;
    color: ${({ $fontColor }) => $fontColor};
    border-bottom: ${({ $fontColor }) => $fontColor} 1px solid;
`;
export const SearchArea = styled.div``;
export const SearchText = styled.div`
    font-size: 14px;
    color: ${theme.colors.grayIconColor};
`;
export const Empty = styled.div`
    padding: 40px 12px;
`;
export const Result = styled.div`
    padding: 20px 12px;
`;
export const Hyphen = styled(RegularFont)`
    line-height: 50px;
    color: ${theme.colors.ultraLightGrayFontColor};
`;
